import { render, staticRenderFns } from "./AppNews.vue?vue&type=template&id=665d5ca2"
var script = {}
import style0 from "./AppNews.vue?vue&type=style&index=0&id=665d5ca2&prod&lang=css"


/* normalize component */
import normalizer from "!../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_857a25aa4406afef410ce4b662efafed/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports